import ClientLayout from 'components/ClientLayout'
import { FeatureEntitlementsProvider } from 'components/FeatureEntitlements'
import AsyncRoute from 'components/AsyncRoute'
import { Redirect, Switch } from 'react-router-dom'

export interface UserRoutesProps {}

function ClientRoutes({}: UserRoutesProps) {
  return (
    <FeatureEntitlementsProvider>
      <ClientLayout>
        <Switch>
          <AsyncRoute path='/settings' page='client/Settings' />
          <AsyncRoute exact path='/welcome' page='client/Welcome' />
          <AsyncRoute exact path='/dashboard' page='client/Dashboard' />
          <AsyncRoute exact path='/products' page='client/Products' />
          <AsyncRoute path='/product/:id' page='client/Product' />
          <AsyncRoute exact path='/gallery' page='client/Gallery' />
          <AsyncRoute exact path='/support' page='client/Support' />
          <AsyncRoute exact path='/support/' page='client/Support' />
          <AsyncRoute exact path='/billing' page='client/Billing' />
          <Redirect to='/welcome' />
        </Switch>
      </ClientLayout>
    </FeatureEntitlementsProvider>
  )
}

export default ClientRoutes
